
















































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { YKDRightDrawer } from 'gum-ui'
import { getRandomCreates } from './config'
import TopicGroup, { TopicPart } from '@/model/exam/topicGroup'
import { State, Action, Getter, namespace } from 'vuex-class'
const TopicPart = namespace('app-exam/topicPart')
import {
  saveTopicPart,
  queryTopicPart,
  deleteTopicPart,
  getTopicPart
} from '@/api/exam/topicGroup'
@Component({
  components: { YKDRightDrawer }
})
export default class CreateTopicPart extends Vue {
  @Prop() private createTopicPartVisable?: boolean
  @Prop() private topicGroupId?: string
  @Prop() private localTopicPart?: TopicPart
  private randomCreates: any[] = getRandomCreates()
  private topicPart: TopicPart = {}
  @TopicPart.State('topicParts') topicParts!: TopicPart[]

  @TopicPart.Action('saveTopicPart') saveTopicPart!: Function
  @TopicPart.Action('editTopicPart') editTopicPart!: Function
  @Watch('createTopicPartVisable')
  inieData() {
    if (this.localTopicPart && this.localTopicPart.id) {
      this.topicPart = {
        ...this.localTopicPart
      }
    }
  }
  close() {
    this.topicPart = {}
    this.$emit('closeCreateTopicPart')
  }
  async confirm() {
    //添加分组
    this.topicPart.topicGroupId = this.topicGroupId
    if (this.localTopicPart && this.localTopicPart.id) {
      const topicPart = await getTopicPart(this.localTopicPart.id)
      if (topicPart.records && topicPart.records.length > 0) {
        //判断修改的是随机固定

        if (topicPart.randomCreate != this.topicPart.randomCreate!) {
          this.$message.error('该分组有题目，不能修改分组随机类型')
          return
        } else {
          await this.editTopicPart(this.topicPart)
          this.$emit('confirmCreateTopicPart', this.topicPart, false)
        }
      } else {
        await this.editTopicPart(this.topicPart)
        this.$emit('confirmCreateTopicPart', this.topicPart, false)
      }
    } else {
      await this.saveTopicPart(this.topicPart)
      this.$emit('confirmCreateTopicPart', this.topicPart, true)
    }

    this.topicPart = {}
  }

  changeRandom(e: any) {
    console.log(e, '4')
    this.topicPart.randomCreate = !!e
    this.$forceUpdate()
  }
}
